import statistImage from "../development/statist.jpg";

const Stat = () => {
  const bgStyle = {
    backgroundImage: `url(${statistImage})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    width: '100%',
    color: '#fff',
 
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    textAlign: 'center',
    position: 'relative',
  };

  const overlayStyle = {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    padding: '80px 0',
    width: '100%',
    height: '100%',
  };

  const statStyle = {
    fontSize: '3rem',
    fontWeight: 'bold',
  };

  const labelStyle = {
    fontSize: '1.2rem',
    marginTop: '10px',
  };

  return (
    <div  style={bgStyle}>
      <div  style={overlayStyle}>
        <div className="container">
          <div className="row text-center">
            <div className="col-md-3 col-6 mb-4">
              <div style={statStyle}>500<span>+</span></div>
              <div style={labelStyle}>Shoot Completed</div>
            </div>
            <div className="col-md-3 col-6 mb-4">
              <div style={statStyle}>15<span>+</span></div>
              <div style={labelStyle}>Years of Experience</div>
            </div>
            <div className="col-md-3 col-6 mb-4">
              <div style={statStyle}>10<span>+</span></div>
              <div style={labelStyle}>Team Members</div>
            </div>
            <div className="col-md-3 col-6 mb-4">
              <div style={statStyle}>780<span>+</span></div>
              <div style={labelStyle}>Client Reviews</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Stat;
